var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { HDSProgressIndicator } from "@here/hds-react-components/ProgressIndicator";
var Loader = function (_a) {
    var _b = _a.classes, classes = _b === void 0 ? "" : _b;
    return (_jsx("div", __assign({ className: "spinnerContainer ".concat(classes) }, { children: _jsx(HDSProgressIndicator, { variant: "indeterminate", indicatorType: "circular", size: "large", color: "accent" }) })));
};
export default Loader;
